import script from "./ExperienceDetailBody.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperienceDetailBody.vue?vue&type=script&setup=true&lang=js"

import "./ExperienceDetailBody.vue?vue&type=style&index=0&id=54872434&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54872434"]])

export default __exports__